<template>
  <ul>
    <li
      v-for="(itemAside, index) in itemsAsideMenu"
      :key="index"
    >
      <router-link
        v-if="itemAside.to"
        :class="itemAside.class"
        :to="itemAside.to"
      >
        <span class="m-item-aside-icon">
          <i :class="itemAside.icon"></i>
        </span>
        <span>{{ itemAside.text }}</span>
      </router-link>
      <a
        v-else
        href="#"
        :class="itemAside.class"
        @click.prevent="emitAction(itemAside)"
      >
        <span class="m-item-aside-icon">
          <i :class="itemAside.icon"></i>
        </span>
        <span>{{ itemAside.text }}</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AtomEditionSectionNavigationMenu',

  props: {
    itemsAsideMenu: Array
  },

  methods: {
    emitAction (itemAside) {
      this.$emit(itemAside.method, itemAside.params)
    }
  }
}
</script>
